import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-950 px-4">
      <div className="text-center">
        <div className="font-heading text-8xl text-primary-400 mb-4">404</div>
        <h1 className="font-heading text-2xl text-foreground-200 mb-3">页面未找到</h1>
        <p className="text-foreground-500 mb-8 max-w-md mx-auto">
          你访问的页面可能已被移除、链接无效，或者在黑夜中迷失了方向。
        </p>
        <Link
          to="/"
          className="inline-flex px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-lg transition-all duration-200 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}